export default {
  subtitle: 'Liên hệ tư vấn',
  title: 'Liên hệ với ORBRO',
  description: 'Nếu bạn có bất kỳ thắc mắc nào về dịch vụ hoặc giải pháp ORBRO như dưới đây, xin hãy liên hệ với chúng tôi bất cứ lúc nào.',
  checkList: [
    'Phí sử dụng dịch vụ là bao nhiêu?',
    'Có dịch vụ tùy chỉnh không?',
    'Có thể liên kết với các dịch vụ khác không?',
    'Tôi muốn triển khai giải pháp.',
    'Tôi muốn nhận hỗ trợ kỹ thuật.',
    'Tôi muốn mua sản phẩm.',
  ],
  call: 'Nếu cần phản hồi nhanh, vui lòng liên hệ số<br/><strong>1522-9928</strong>.',
  callTime: 'Thời gian làm việc:  ngày thường, 10:00 ~ 19:00)',
  form: {
    name: 'Họ tên',
    namePlaceholder: 'Nguyễn Văn A',
    title: 'Chức vụ',
    titlePlaceholder: 'Không bắt buộc',
    companyName: 'Tên công ty',
    companyNamePlaceholder: 'Vui lòng nhập tên công ty',
    email: 'Email công việc',
    emailPlaceholder: 'name@company.com',
    phoneNumber: 'Số điện thoại',
    phoneNumberPlaceholder: '090-1234-5678',
    comment: 'Bạn cần hỗ trợ gì?',
    commentPlaceholder: 'Vui lòng nhập nội dung như yêu cầu báo giá, tư vấn giải pháp hoặc đề xuất hợp tác kinh doanh.',
    policy: {
      require: '[Bắt buộc]',
      agree: 'Đồng ý',
      policy1: 'Chính sách xử lý dữ liệu cá nhân',
    },
    submit: 'Liên hệ tư vấn',
  },
};
